/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DoeInputs */

const en_doe = /** @type {(inputs: DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doe`)
};

const de_doe = /** @type {(inputs: DoeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doe`)
};

/**
* | output |
* | --- |
* | "Doe" |
*
* @param {DoeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const doe = /** @type {((inputs?: DoeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DoeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doe(inputs)
	return de_doe(inputs)
});